export default __webpack_public_path__ + "static/media/topic930.41c153f3.png";